import { useRecoilValue } from 'recoil';
import { downloadLoadingState } from 'recoil/loading/downloadLoadingState';

export const DownloadLoadingOverlay = () => {
  const isLoading = useRecoilValue(downloadLoadingState);

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <div style={{ textAlign: 'center', color: '#fff' }}>
        <div className='spinner-border' role='status' style={{ width: '3rem', height: '3rem' }}>
          <span className='visually-hidden'>Loading...</span>
        </div>
        <div style={{ marginTop: '16px', fontSize: '16px', fontWeight: '500' }}>
          파일을 다운로드 중입니다...
        </div>
      </div>
    </div>
  );
};
